/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const AudioIcon = ({muted}) => {
  if (muted) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13"
           viewBox="0 0 16 13">
        <defs>
          <path id="a" d="M0 .042h9V13H0z"/>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g>
            <mask id="b" fill="#fff">
              <use xlinkHref="#a"/>
            </mask>
            <path
              fill="#FFF"
              d="M7.2.27L3 3.385H.97c-.529 0-.97.41-.97.94v4.397c0 .513.424.94.97.94h2.048L7.2 12.775c.724.547 1.8.034 1.8-.856V1.126C8.982.219 7.924-.277 7.2.27"
              mask="url(#b)"/>
          </g>
          <path
            fill="#FFF"
            d="M14.734 7l1.125-1.35c.188-.225.188-.6 0-.844l-.53-.637c-.188-.225-.5-.225-.704 0L13.5 5.519l-1.125-1.35c-.187-.225-.5-.225-.703 0l-.531.637c-.188.225-.188.6 0 .844L12.266 7 11.14 8.35c-.188.225-.188.6 0 .844l.53.637c.188.225.5.225.704 0l1.125-1.35 1.125 1.35c.188.225.5.225.703 0l.531-.637c.188-.225.188-.6 0-.844L14.734 7z"/>
        </g>
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13">
        <defs>
          <path id="a" d="M0 .042h9V13H0z"/>
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a"/>
          </mask>
          <path fill="#FFF" d="M7.2.27L3 3.385H.97c-.529 0-.97.41-.97.94v4.397c0 .513.424.94.97.94h2.048L7.2 12.775c.724.547 1.8.034 1.8-.856V1.126C8.982.219 7.924-.277 7.2.27" mask="url(#b)"/>
          <rect width="2" height="5" x="10" y="4" fill="#FFF" fillRule="nonzero" rx="1"/>
          <rect width="2" height="7" x="13" y="3" fill="#FFF" fillRule="nonzero" rx="1"/>
        </g>
      </svg>
    );
  }
};

AudioIcon.propTypes = {
  muted: PropTypes.bool
};

export default AudioIcon;